module.exports = __webpack_public_path__ + "img/cloud3.cb38347.png";